import { render } from "./TheRentalCommand.vue?vue&type=template&id=be930a6a"
import script from "./TheRentalCommand.vue?vue&type=script&lang=js"
export * from "./TheRentalCommand.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__